import {ContentListProps} from 'presentation/components/StyledCard/types';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {formatText} from 'presentation/utils';
import {useNavigate} from 'react-router-dom';

import {FeaturesEnum, MyAppointmentsEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useBookingTheme} from 'presentation/modules/booking/shared/hooks/useBookingTheme';
import {getAppointmentClinicName} from 'presentation/modules/myAppointments/utils/getAppointmentClinicName';
import {isAdvanceDiagnosticsAppointment} from 'presentation/modules/myAppointments/utils/isAdvanceDiagnosticsAppointment';
import {translations} from 'presentation/translations-new';
import {UseExamDuplicityBookedCardProps} from './types';

const {selectedProcedure} = translations['pt-br'].privateFlow.bookingFlow.examSelection;

export function useExamDuplicityBookedCard({scheduledBooking}: UseExamDuplicityBookedCardProps) {
	const navigate = useNavigate();
	const {userName} = useAccountInformation();
	const {color, variant, iconName} = useBookingTheme({
		flowType: FlowEnum.EXAM,
	});
	const {isEnabled: isAdvanceDiagnosticsExamsJourneyEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_ADVANCE_DIAGNOSTICS_EXAMS_JOURNEY,
	);

	const isAdvanceDiagnosticsExam = isAdvanceDiagnosticsAppointment({
		appointment: scheduledBooking,
		isAdvanceDiagnosticsExamsJourneyEnabled,
	});
	const clinicName = getAppointmentClinicName({
		appointment: scheduledBooking,
		isAdvanceDiagnosticsExamsJourneyEnabled,
	});

	function handleGoToDetails() {
		navigate(
			MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_EXAM.replace(
				':id',
				scheduledBooking.bookingNumber,
			),
		);
	}

	const CONTENT_LIST: ContentListProps[] = [
		{
			primaryText: formatText(userName),
			iconName: 'account-circle-filled',
		},
		{
			primaryText: formatText(
				isAdvanceDiagnosticsExam
					? scheduledBooking.specialtyName
					: scheduledBooking.providerName,
			),
			secondaryText: isAdvanceDiagnosticsExam
				? selectedProcedure
				: formatText(scheduledBooking.specialtyName),
			secondaryTextColor: 'text.secondary',
			iconName: 'medical-services-filled',
		},
		{
			primaryText: formatText(clinicName),
			iconName: 'location-on-filled',
		},
	];

	return {
		handleGoToDetails,
		CONTENT_LIST,
		color,
		variant,
		iconName,
	};
}
